import { OptionalMiddlewareRequest } from './OptionalMiddlewareContext'
import { requestContextRequest } from './requestContext'
import { CashRequestMiddleware } from './types'

export const excludeRequestContext: OptionalMiddlewareRequest = (requestMiddleware: CashRequestMiddleware[]) =>
  requestMiddleware.filter(middleware => middleware !== requestContextRequest)
